// this code will be a subject to extensive refactoring!!

// TODO: i18n!


(function() {
  'use strict';

  var actionButton = function ($sce, $q, $timeout, $templateCache, ajaxCall) {
    return {
        restrict: 'EA',
        replace: true,
        scope: true,
        bindToController: {
            multiActionPath: '@', // not in use ?
            ajaxUrl: '@',
            actionContext: '@',
            ajaxForm: '@',
            id: "@",
            alwaysrefresh: "@"
        },
        controllerAs: 'ctrl',
        controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
            // TODO: prepare ajaxFrom and ajaxContent to not to be shown in the template if empty (?)

            var _this = this;

            // register element and scope
            this.scope = $scope;
            this.element = $element;

            this.$onInit = function() {
                if(!angular.isDefined(_this.urlsData)){ // TODO: refactoring with this order mess...
                    _this.urlsData = {action:{}}; // if there's no action here the order is reversed in the menu (multiactions shouldn't be first)
                }
            }

            this.getInnerMenu = function() {
                // ajax call

                var spinnerMsg      = '<li><a><i class="loading-spinner gray-bg" style="margin-bottom:0">Please wait...</i></a></li>';
                var errorMsg        = '<li><a>Connection or other problem occurred. <br /><small style="font-size:0.8em">(Your session may have expired - you may try to re-login).</small></a></li>';
                var multiObjectSelectionErrorMsg = '<li><a>No actions available as different object types have been selected. Please reselect.</a></li>';
                var sessionTimeoutErrorMsg = '<li><a>Session timeout.</a></li>';
              var permissionDeniedErrorMsg = '<li><a>You do not have permission to perform this action.</a></li>';

                // show ajax loader in there
                $scope.innerMenu = $sce.trustAsHtml(spinnerMsg);

                // X3-4788 workaround to pass searchTotalNumber to backend
                var searchResultLabel = $('.searchResultMarker');
                if(_this.urlsData.multiaction && searchResultLabel.length) {
                    _this.urlsData.multiaction.url += '&searchResultTotalNumber=' + searchResultLabel.html();
                }

                var innerMenuContentArray = new Array();

                angular.forEach(_this.urlsData, function(obj){

                    var length = innerMenuContentArray.push( spinnerMsg );

                    ajaxCall.getData(obj.url, obj.data).then(
                        function(result) {
                            innerMenuContentArray[length-1] = result.data;
                            console.log(innerMenuContentArray);
                            $scope.innerMenu = $sce.trustAsHtml( innerMenuContentArray.join('<li class="dropdown-divider"></li>') );
                        },
                        function(result) {
                            if(result.status === 422 && result.data.message === 'MULTI_DOMAIN'){
                                innerMenuContentArray[length - 1] =multiObjectSelectionErrorMsg;
                            }else if(result.status === 401){
                                innerMenuContentArray[length - 1] =sessionTimeoutErrorMsg;
                            }else if(result.status === 403){
                              innerMenuContentArray[length - 1] = permissionDeniedErrorMsg;
                            }else {
                                innerMenuContentArray[length - 1] = errorMsg;
                            }
                            $scope.innerMenu = $sce.trustAsHtml(innerMenuContentArray.join('<li class="dropdown-divider"></li>'));
                        }
                    );
                });
            };

            this.getMenu = function(event) {

                $scope.openMenu();

                // show ajax loader in there
                // TODO: move into getInnerMenu
                $scope.innerMenu = $sce.trustAsHtml('<li><a><i class="loading-spinner gray-bg" style="margin-bottom:0">Please wait...</i></a></li>');
                // getMenu

                if( angular.isDefined(_this.ajaxUrl) && _this.ajaxUrl!='' ){
                    _this.urlsData['action'] = {url: _this.ajaxUrl};
                } else {
                    delete _this.urlsData['action']; // it's already set to fix reversed order problem... :-/
                }
                _this.getInnerMenu();

                event.stopPropagation();
                event.preventDefault();
            };

        }],
        require: 'actionButton',
        transclude: true,
        //Temporary fix for XMS-7460.
        //Should be reverted after Financial statement module refactor
        templateUrl: WEBAPP_PATH + '/js/angular/src/components/actionButton.html',
        link: {
            // "pre" used for events, so we can easily unbind them in directive extensions (ie. multiaction unbinds mouseover)
            pre: function (scope, elem, attrs, ctrl) {

                var timer;

                scope.closeMenu = function(){
                    scope.menuOpen = false;
                }
                scope.openMenu = function(){
                    scope.menuOpen = true;
                }

                elem.bind("click", function(event){
                    if( scope.innerMenu !== undefined ) {
                        // (*) hence we need clear it here
                        $timeout.cancel(timer);
                        if( !angular.isDefined(ctrl.alwaysrefresh) || ctrl.alwaysrefresh=="false" ){
                            // open menu only if it's not empty
                            scope.$apply(function() {
                                scope.openMenu();
                            });
                        }
                    }
                });

                // Best Practice: Directives should clean up after themselves. You can use elem.on('$destroy', ...) or scope.$on('$destroy', ...) to run a clean-up function when the directive is removed.
                elem.on('$destroy', function() {
                    $timeout.cancel(timer);
                });
            },

            post: function (scope, elem, attrs, ctrl) {
                scope.menuOpen = false;
            }
        }
    };
  }

  actionButton.$inject = ['$sce', '$q', '$timeout', '$templateCache', 'ajaxCall'];
  angular.module('app').directive('actionButton', actionButton);

}());

